export enum EProjectType {
  WEB_APP = 'web_app',
  MOBILE_APP = 'mobile_app',
  OTHER = 'other',
}
